<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title class="ion-title-icon">{{'Pauta' | translate}}</ion-title>

    <ion-grid>
      <ion-row class="end">
        <ion-col>
          <ion-icon class="icon-zoom" (click)="zoom('in')" name="add-circle"></ion-icon>

          <ion-icon class="icon-zoom-font" (click)="zoom('out')" name="remove-circle"></ion-icon>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <div class="gradient-extendido"></div>
  <ion-card class="gradient-extendido-recuo">
    <ion-card-content>
      <div class="ql-editor">
        <div
          class="trix-content"
          id="trix"
          [innerHTML]="pauta | safeHtml: 'html'"
          [style.font-size.px]="fontSize"
        ></div>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-fab horizontal="end" vertical="bottom" slot="fixed" (click)="download();">
    <ion-fab-button class="ion-fab">
      <ion-icon name="cloud-download"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>